class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//     this.hoverMedia = window.matchMedia('(min-width: 990px) and (pointer: fine)');
//     this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
//     this.addEventListener('mouseleave', this.onHoverClose.bind(this));
//   }

//   static closeAllExcept(except) {
//     document.querySelectorAll('header-menu').forEach((menu) => {
//       if (menu !== except && menu.mainDetailsToggle?.open) {
//         menu.close();
//       }
//     });
//   }

//   static syncHoverClass(isHovered) {
//     const anyMenuOpen = [...document.querySelectorAll('header-menu')]
//       .some((menu) => menu.mainDetailsToggle?.open);

//     document.body.classList.toggle('hover-header', anyMenuOpen || isHovered);
//   }

//   onHoverOpen() {
//     if (!this.hoverMedia.matches) return;
//     if (!this.mainDetailsToggle.open) {
//       HeaderMenu.closeAllExcept(this);
//       this.mainDetailsToggle.setAttribute('open', '');
//       this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
//     }
//   }

//   onHoverClose() {
//     if (!this.hoverMedia.matches) return;
//     if (this.mainDetailsToggle.open) {
//       this.close();
//     }
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     // Reconcile using current header-hover state, not just this menu
//     HeaderMenu.syncHoverClass(this.header.matches(':hover'));

//     if (
//       document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== ''
//     ) {
//       return;
//     }

//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }
// customElements.define('header-menu', HeaderMenu);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.hoverMedia = window.matchMedia(
      '(min-width: 1160px) and (pointer: fine)'
    );

    this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
    this.addEventListener('mouseleave', this.onHoverClose.bind(this));
  }

  static closeAllExcept(except) {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== except && menu.mainDetailsToggle?.open) {
        menu.close();
      }
    });
  }

  // isHovered lets header-level script force the class on/off
  static syncHoverClass(isHovered) {
    if (isHovered === undefined) {
      isHovered = [...document.querySelectorAll('header-menu')]
        .some((menu) => menu.mainDetailsToggle?.open);
    }
    document.body.classList.toggle('hover-header', isHovered);
  }

  onHoverOpen() {
    if (!this.hoverMedia.matches) return;

    clearTimeout(this.hoverCloseTimer);

    HeaderMenu.closeAllExcept(this);

    if (this.mainDetailsToggle && !this.mainDetailsToggle.open) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle
        .querySelector('summary')
        ?.setAttribute('aria-expanded', 'true');
      this.onToggle();
    }
  }

  onHoverClose(event) {
    if (!this.hoverMedia.matches) return;

    // Only close THIS menu's submenu — never touch the body class here.
    // The header-level listener owns the class.
    if (event.relatedTarget && this.contains(event.relatedTarget)) {
      return;
    }

    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => {
      if (this.mainDetailsToggle?.open) {
        this.close();
      }
    }, 100);
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

window.HeaderMenu = HeaderMenu;
customElements.define('header-menu', HeaderMenu);


(function () {
  const hoverMedia = window.matchMedia(
    '(min-width: 1160px) and (pointer: fine)'
  );

  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  let closeTimer;

  // ENTER HEADER — add class immediately, even for items with no submenu
  header.addEventListener('mouseenter', () => {
    if (!hoverMedia.matches) return;

    clearTimeout(closeTimer);
    HeaderMenu.syncHoverClass(true);
  });

  // LEAVE HEADER — only once the mouse fully leaves .header-wrapper
  header.addEventListener('mouseleave', (event) => {
    if (!hoverMedia.matches) return;

    if (event.relatedTarget && header.contains(event.relatedTarget)) {
      return;
    }

    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      HeaderMenu.closeAllExcept(null);
      HeaderMenu.syncHoverClass(false);
    }, 100);
  });
})();

// (function () {
//   const hoverMedia = window.matchMedia('(min-width: 1160px) and (pointer: fine)');
//   const header = document.querySelector('.header-wrapper');
//   if (!header) return;

//   // Single authoritative listener for "mouse entered/left the header entirely"
//   header.addEventListener('mouseenter', () => {
//     if (!hoverMedia.matches) return;
//     HeaderMenu.syncHoverClass(true);
//   });

//   header.addEventListener('mouseleave', (event) => {
//     if (!hoverMedia.matches) return;
//     // Guard against sub-pixel/edge cases where relatedTarget is still inside
//     if (event.relatedTarget && header.contains(event.relatedTarget)) return;

//     HeaderMenu.closeAllExcept(null); // close any still-open menu
//     HeaderMenu.syncHoverClass(false);
//   });

//   // Plain links no longer need their own hover-header logic —
//   // entering/leaving them is just movement *within* the header,
//   // which header's own mouseenter/mouseleave already ignores correctly
//   // (mouseleave only fires when relatedTarget is outside .header-wrapper).
// })();